import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetMessages, LikeMessage, SendMessage } from '../../../store/sockets/actions';
import { AppStore } from '../../../store/applicationState';

export const useChat = () => {
  const [loading, setLoading] = React.useState(false);

  const Sockets = useSelector((store: AppStore) => store.Sockets);
  const dispatch = useDispatch();

  const sendMessage = React.useCallback(
    (myMessage: string) => {
      if (Sockets.room) {
        setLoading(true);
        dispatch(
          SendMessage.request({
            data: {
              event_id: Sockets.room.event_id,
              roomId: Sockets.room.absnum,
              message: myMessage,
              comment: null,
            },
            callBack: () => {
              setLoading(false);
            },
          })
        );
      }
    },
    [dispatch, Sockets.room]
  );

  const likeMessage = React.useCallback(
    (messageId: number) => {
      if (Sockets.room) {
        dispatch(
          LikeMessage.request({
            data: {
              event_id: Sockets.room.event_id,
              roomId: Sockets.room.absnum,
              messageId: messageId,
            },
          })
        );
      }
    },
    [dispatch, Sockets.room]
  );

  const handleChangePage = React.useCallback(() => {
    if (!Sockets.room) return null;
    if (!Sockets.chat) return null;

    const chat = Sockets.chat;

    if (!loading && chat && chat.page < chat.pages) {
      setLoading(true);

      dispatch(
        GetMessages.request({
          data: {
            event_id: Sockets.room.event_id,
            roomId: Sockets.room.absnum,
            page: chat.page + 1,
          },
          callBack: () => setLoading(false),
        })
      );
    }
  }, [dispatch, loading, Sockets.room, Sockets.chat]);

  return {
    loading,
    sendMessage,
    likeMessage,
    handleChangePage,
  };
};
